const isArray = arrayValue => {
  return arrayValue && Array.isArray(arrayValue);
};

module.exports = isArray;
